import { useState } from 'react';
import { friendlyErrorMessage } from '../../../shared/friendlyError';
import { identityGateway } from '../../identity/services';

export function StepUpDialog({ onVerified, onCancel }: { onVerified: () => void; onCancel: () => void }) {
  const [sent, setSent] = useState(false);
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function sendCode() {
    setBusy(true);
    setError(null);
    try {
      await identityGateway.requestStepUp();
      setSent(true);
    } catch (err) {
      setError(friendlyErrorMessage(err, 'Could not send a verification code.'));
    } finally {
      setBusy(false);
    }
  }

  async function verify() {
    setBusy(true);
    setError(null);
    try {
      await identityGateway.verifyStepUp(code);
      onVerified();
    } catch (err) {
      setError(friendlyErrorMessage(err, 'That code is not valid or has expired.'));
      setBusy(false);
    }
  }

  return (
    <div role="dialog" aria-modal="true" aria-labelledby="step-up-title" data-testid="step-up-dialog">
      <h3 id="step-up-title">Verify it&apos;s you</h3>
      <p>For your security, confirm this change with a one-time code sent to your account email.</p>
      {error && (
        <p className="error" role="alert">
          {error}
        </p>
      )}
      {!sent ? (
        <button type="button" disabled={busy} onClick={() => void sendCode()}>
          {busy ? 'Sending…' : 'Email me a code'}
        </button>
      ) : (
        <>
          <p>We sent a 6-digit code to your account email. It expires shortly.</p>
          <label>
            6-digit code
            <input value={code} onChange={(e) => setCode(e.target.value)} maxLength={6} inputMode="numeric" autoComplete="one-time-code" />
          </label>
          <div>
            <button type="button" disabled={busy || code.length !== 6} onClick={() => void verify()}>
              {busy ? 'Verifying…' : 'Verify'}
            </button>
            <button type="button" className="link" disabled={busy} onClick={() => void sendCode()}>
              Send a new code
            </button>
          </div>
        </>
      )}
      <button type="button" className="link" onClick={onCancel}>
        Cancel
      </button>
    </div>
  );
}
